module.exports = __webpack_public_path__ + "img/jjj_jbt7270_2.prt.589f6047.jpg";